import React from 'react';
import * as Sentry from '@sentry/react';
import { Typography, Paper, Alert } from '@mui/material';
import { createLogger } from '../utils/logger';

const logger = createLogger('ErrorBoundary');


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ErrorBoundary caught render error', {
      view: 'app',
      component_stack: errorInfo?.componentStack,
    }, error);
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo?.componentStack },
      tags: { view: 'app' },
    });
    this.setState({ error: error, errorInfo: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Paper elevation={3} sx={{ m: 2, p: 2, border: '1px solid red' }}>
          <Alert severity="error">
            <Typography variant="h6">Something went wrong.</Typography>
            <Typography variant="body2">A component failed to render. This is likely due to an unexpected data format from the API.</Typography>
            {this.state.error && (
              <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
                <summary>Error Details</summary>
                {this.state.error.toString()}
                <br />
                {this.state.errorInfo?.componentStack}
              </details>
            )}
          </Alert>
        </Paper>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary; 